import { Types } from '../actionTypes';


const initState = { token:''  };

const token = (state = initState, action) => {
  if (action.type === Types.SAVE_USER_TOKEN) {
    return {
      ...state,
      token: action.payload 
    }
    };

  if (action.type === Types.DEL_USER_TOKEN) {
    return {
      ...state,
      token: action.payload 
    };
  }

  if (action.type === Types.USE_REFRESH_TOKEN) {
    return {
      ...state,
      token: action.payload 
    };
  }

  //if (action.type === DESTROY_SESSION)
  //  state = null;


  return state;
};

export default token;
